import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import actionCreators from "../../actionCreators/index.js";
import SpreadAndMarginAccordion from "./spreadAndMarginAccordion";

function mapStateToProps(state) {
  return {
    transactionRequest: state.transactionRequest,
    transactions: state.transactions,
    bids: state.bids,
    paymentType: state.paymentType,
    actionType: state.actionType,
    texts :state.translatedTexts
  };
}

function mapDispatchToProps(dispatch) {
  let actionDispatchers = bindActionCreators(actionCreators, dispatch);
  return actionDispatchers;
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SpreadAndMarginAccordion);
